import type {
  Condition,
  BackupZeroEtlIdentityColumnSpec,
  BackupZeroEtlRoutingMode,
} from '@repo/api-gw-sdk';

import type { ResourcesScopeType } from '@/components/resourcesSelection/resourceSelectionDynamicViewer';
import type { Step } from '@/components/wizard/Step';

import { ZeroEtlPolicyConditionEditor } from './ZeroEtlPolicyConditionEditor';
import { ZeroEtlPolicyNameSelection } from './ZeroEtlPolicyNameSelection';
import { ZeroEtlPolicyResourcesList } from './ZeroEtlPolicyResourcesList';
import { ZeroEtlPolicyTableAccess as ZeroEtlPolicyTableAccess } from './zeroEtlPolicyTableAccess';
import { ZeroEtlPolicyTableDefinition as ZeroEtlPolicyTableDefinition } from './zeroEtlPolicyTableDefinition';

export const FULLY_QUALIFIED_NAMESPACE =
  '{source_cloud}.{source_account_id}.{source_region}.{resource_id}.{database_name}.{schema_name}';
export const FULLY_QUALIFIED_TABLE = '{table_name}';

export interface ZeroEtlPolicyEditState {
  id: string;
  name: string;
  condition?: Condition;
  focusOnName: boolean;
  include: string[];
  exclude: string[];
  resourcesScopeType: ResourcesScopeType;
  catalogAwsAccountId: string;
  catalogAwsRegion: string;
  catalogIamRoleArn: string;
  vaultId: string;
  allowedPrincipals: string[];
  requirePrincipalTags: boolean;
  routingMode: BackupZeroEtlRoutingMode;
  namespaceTemplate: string;
  tableTemplate: string;
  identityColumns: BackupZeroEtlIdentityColumnSpec[];
  showAdditionalColumnsSection: boolean;
}

export const EditZeroEtlPolicyFlow: Step<ZeroEtlPolicyEditState> = {
  id: 'name_selection',
  Component: ZeroEtlPolicyNameSelection,
  nonReturnable: true,
  next: [
    {
      id: 'resource_selection',
      Component: ZeroEtlPolicyConditionEditor,
      next: [
        {
          id: 'resource_list',
          Component: ZeroEtlPolicyResourcesList,
          next: [
            {
              id: 'table_definition',
              Component: ZeroEtlPolicyTableDefinition,
              next: [
                {
                  id: 'table_access',
                  Component: ZeroEtlPolicyTableAccess,
                },
              ],
            },
          ],
        },
      ],
    },
  ],
};
